import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {MeteringRecord} from '../types';
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<MeteringRecord, 'id'>,
    handleSubmit: (values: MeteringRecord) => void,
    handleCancel?: () => void
}) => {

    const onSubmit = (values: MeteringRecord) => {
        handleSubmit(values);
    };

    const onCancel = () => {
        handleCancel?.();
    };

    let initialValues = {} as MeteringRecord;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent {...rest} />
                </FormWithButtons>)}
        </Formik>
    );
};
